interface FormatPriceOptions {
  removeSpaces?: boolean;
  hideCents?: boolean;
}

export const formatPrice = (value: number, options: FormatPriceOptions = {}): string => {
  const { removeSpaces = false, hideCents = false } = options;
  const prefix = 'R$';
  const spaceString = removeSpaces ? '' : ' ';

  return `${prefix}${spaceString}${value
    .toFixed(hideCents ? 0 : 2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
};

